import React, { useState } from "react"
import Image from "gatsby-image"
import styled from "styled-components"

import { saveLead, checkEmail } from "../../utils/emails"

import Techo from "../Donate/Techo"
import Organizadores from "../Donate/Organizadores"
import Proposito from "../Donate/Proposito"
import Moderadores from "../Donate/Moderadores"
import Parser from "html-react-parser"
import Spinner from "../../images/meets/Spinner.gif"
import { Row, Col } from "react-bootstrap"

let ShowDonate = props => {
  const [email, setEmail] = useState(props.email)
  const [submitted, setSubmitted] = useState(props.submitted)
  const [toVideo, setToVideo] = useState(props.toVideo)
  const [disabledButton, setDisabledButton] = useState(props.disabledButton)
  const [loading, setLoading] = useState(props.loading)

  const handleSuccess = () => {
    saveLeads(email)
    setToVideo(true)
    console.log("funcionaaaaa")
  }

  const saveLeads = async email => {
    setLoading(false)
    if (checkEmail(email)) {
      await saveLead(email, props.id, props.templateId, props.text, email)

      setLoading(false)
      setSubmitted(true)
    }
  }

  return (
    <>
      <Proposito></Proposito>
      <Row
        style={{
          justifyContent: "center",
          backgroundColor: "#9286D1",
        }}
      >
        <Title>
          {!toVideo && Parser(" ¿Deseas ver nuestro webinar? ")}

          {toVideo && Parser("Muchas gracias, disfruta de nuestro webinar")}

          {/* {loading &&
                      (toVideo
                        ? "Muchas gracias, ahora disfruta de nuestro webinar"
                        : "¿Deseas ver nuestro webinar?")} */}
        </Title>
      </Row>
      {!toVideo && (
        <Row
          style={{
            justifyContent: "center",
            backgroundColor: "#9286D1",
            paddingBottom: "3rem",
          }}
        >
          <form
            style={{
              justifyContent: "center",
              width: "100%",
              textAlign: "center",
            }}
            onSubmit={e => {
              e.preventDefault()
              setDisabledButton(true)
              handleSuccess()
            }}
          >
            <ImputMail
              placeholder="correo electrónico"
              onChange={e => {
                setEmail(e.target.value)
                setSubmitted(false)
              }}
              required
              value={email}
              type="email"
            />

            <BtnSend disabled={disabledButton}>
              {loading ? (
                "Enviar"
              ) : (
                <img
                  src={Spinner}
                  alt="loading"
                  style={{
                    width: "22px",
                  }}
                ></img>
              )}
            </BtnSend>
          </form>
        </Row>
      )}

      {toVideo && (
        <Row
          style={{
            justifyContent: "center",
            backgroundColor: "#9286D1",
            paddingBottom: "3rem",
          }}
        >
          <DivVideo>
            <iframe
              title="video webinar"
              className="responsive-iframe"
              width="1280"
              height="720"
              frameborder="0"
              src={props.linkVideo}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              style={{ border: "none" }}
              allowfullscreen="allowfullscreen"
              mozallowfullscreen="mozallowfullscreen"
              msallowfullscreen="msallowfullscreen"
              oallowfullscreen="oallowfullscreen"
              webkitallowfullscreen="webkitallowfullscreen"
            ></iframe>
          </DivVideo>
        </Row>
      )}

      <Techo></Techo>
      <Organizadores></Organizadores>
      <Moderadores></Moderadores>
    </>
  )
}

export default ShowDonate

const ImputMail = styled.input`
  padding: 1rem 4rem 1rem 1rem;
  margin-right: 2rem;
  border-radius: 6px;
  border-width: 0;
  @media (max-width: 502px) {
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 1rem 5rem 1rem 1rem;
  }
  @media (max-width: 339px) {
    padding: 1rem 3rem 1rem 1rem;
  }
`
const BtnSend = styled.button`
  background-color: #efefef !important;
  padding: 1rem 2rem 1rem 2rem;
  border-radius: 6px;
  border-width: 0;
  :active {
    background-color: #efefef !important;
  }
  :hover {
    background-color: #efefef !important;
  }
  :visited {
    background-color: #efefef !important;
  }
  :link {
    background-color: #efefef !important;
  }
`
const Title = styled.h2`
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  margin-top: 4rem;
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`
const DivVideo = styled.div`
  text-align: center;
  max-width: 1536px;
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`
